export class GetVariableNameArgs {
    constructor(name, groupName, code) {
        this.name = name;
        this.groupName = groupName;
        this.code = code;
    }
}
